import { createAction } from "redux-actions";
import { GET_METER_CORE, CREATE_METER_CORE, GET_METERS_LIST, PROCESS_METER_PAYMENT_CORE, CREATE_PROCESS_METER_CODE } from "../constants";
import { feathersCreateData, feathersFindDataAll } from "../services";

export const getMeterCore = createAction(GET_METER_CORE, (data) => feathersCreateData('core-server', {
    service: 'COLLECTIONS',
    func: 'GET_METER_VALUE',
    data
})())

export const processMeterPayment = createAction(PROCESS_METER_PAYMENT_CORE, (data) => feathersCreateData('core-server', {
    service: 'COLLECTIONS',
    func: 'PROCESS_METER_PAYMENT',
    data
})())

export const createMeterCore = createAction(CREATE_METER_CORE, (data) => feathersCreateData('codes-recovery', data)())
export const createProcessMeterCode = createAction(CREATE_PROCESS_METER_CODE , (data) => feathersCreateData('codes-recovery', data)())
export const getMetersList = createAction(GET_METERS_LIST, (user) => feathersFindDataAll('meters',{user})())